import config from "../../config";
import Moment from "moment";
import $ from "jquery";
import Sidebar from "../../components/partials/Sidebar";
import Header from "../../components/partials/Header";
import Breadcrumb from "../../components/Breadcrumb";
import { useEffect, useState, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import "./style.css";
import Pagination from "../../components/Pagination";
import Tippy from "@tippyjs/react";
import deleteIcon from "../../images/icons/delete.png";
import "tippy.js/dist/tippy.css";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import viewIcon from "../../images/icons/view.png";
import CommonAsyncSelect from "../../components/CommonAsyncSelect";
import Swal from "sweetalert2";
import DateRangeFilter from "../../components/DateRangeFilter";
import filter from "../../images/icons/filter.png";
import DownloadExcel from "../../components/DownloadExcel";
import { millionComma } from "../../utils";
import moment from "moment";
import { ConfigContext } from "../../App";
import { FaInfoCircle } from "react-icons/fa";

function ExpenseList(props) {
  const location = useLocation();
  const erpIntegration = useContext(ConfigContext)?.erpIntegration;
  const [isErpLoading, setIsErpLoading] = useState(false);

  const [user, setUser] = useState({});

  useEffect(function () {
    if (localStorage.getItem("inventory")) {
      setUser(JSON.parse(localStorage.getItem("inventory")).userData);
    }
  }, []);

  const initialState = {
    exp_hdr_id: "",
    exp_hdr_no: "",
    exp_type: "",
    exp_cat_id: "",
    from_date: "",
    to_date: "",
    is_active: "",
    branch_id: "",
    sync_status: "",
  };

  let newFilter = location.state?.appliedFilter || initialState;
  let newFilterVisiblity = location.state?.filterDisplay;
  let backToCurrPage = location.state?.backToCurrent;

  const [formInputs, setFormInputs] = useState(newFilter);
  const [filtersVisible, setFiltersVisible] = useState(
    newFilterVisiblity === true ? true : false,
  );
  const [filterActive, setFilterActive] = useState(
    location.state?.appliedFilter ? true : false,
  );
  const [isSubmit, setIsSubmit] = useState(false);

  const [list, setList] = useState([]);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(
    backToCurrPage ? backToCurrPage : 1,
  );
  const [totalPage, setTotalPage] = useState(0);

  const initialPageSize = location.state?.pageSize || 10;
  const [userCount, setUserCount] = useState(initialPageSize);

  const [selectedCategory, setSelectedCategory] = useState(null);
  const [filterDate, setFilterDate] = useState();
  let dates = filterDate && JSON.parse(filterDate.date);

  function handleInputDate(e) {
    setFilterDate((prevState) => {
      return {
        ...prevState,
        [e.target.name]: e.target.value,
      };
    });
  }

  function toggleItemDetail(id) {
    $(`#${id}`).is(":visible")
      ? $(`#${id}`).addClass("d-none")
      : $(`#${id}`).removeClass("d-none");
  }

  function changeStatus(exp_hdr_id, is_active) {
    let branch_id = JSON.parse(localStorage.getItem("inventory"))?.userData
      ?.branch_data?.[0]?.branch_id;
    confirmAlert({
      title: "Are you sure?",
      message: "You want to cancel expense.",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            $.post(
              `${config.apiUrl}/expense/cancelExpense`,
              JSON.stringify({ exp_hdr_id, branch_id, is_active }),
            )
              .done(function (res) {
                getList(filtersVisible);
                setError("");
                setSuccess(res?.data?.message);
                setTimeout(function () {
                  setSuccess("");
                }, 4000);
              })
              .catch(function (err) {
                setSuccess("");
                setError(
                  err?.responseJSON?.data?.message ||
                    err?.responseJSON?.message,
                );
                setTimeout(function () {
                  setError("");
                }, 4000);
              });
          },
        },
        {
          label: "No",
        },
      ],
    });
  }

  async function getList(isFilter = true, pageNo = null, perPage = null) {
    let json = {
      paginate: 1,
      page_no: (pageNo || currentPage) - 1,
      branch_id: JSON.parse(localStorage.getItem("inventory"))?.userData
        ?.branch_data?.[0]?.branch_id,
    };
    if (isFilter) {
      Object.keys(formInputs).forEach((key) => {
        if (formInputs[key] !== "") {
          json[key] = formInputs[key];
        }
      });
    }
    json.page_size = perPage || userCount;
    await $.post(`${config.apiUrl}/expense/listExpense`, JSON.stringify(json))
      .done(function (res) {
        setCurrentPage(pageNo || currentPage);
        setList(res.data?.list || []);
        setTotalPage(res.data?.count || 0);
        setIsLoading(false);
        setIsSubmit(false);
      })
      .catch(function (err) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: err?.responseJSON?.data?.message || err?.responseJSON?.message,
          confirmButtonText: "OK",
          allowEnterKey: false,
          allowEscapeKey: false,
          allowOutsideClick: false,
          focusConfirm: true,
        });
      })
      .always(function () {
        setIsSubmit(false);
      });
  }

  useEffect(
    function () {
      getList(filterActive);
    },
    [currentPage],
  );

  function handleInputs(e) {
    setFormInputs({ ...formInputs, [e.target.id]: e.target.value });
  }

  function handleFilterVisibility() {
    if (filtersVisible) {
      setFiltersVisible(false);
      setFormInputs(initialState);
    } else {
      setFiltersVisible(true);
    }
  }

  const changePageSize = async (e) => {
    setUserCount(() => e.target.value);
    if (list.length > 0) {
      currentPage == 1
        ? await getList(filterActive, 1, e.target.value)
        : setCurrentPage(() => 1);
    }
  };

  const [exportIds, setExportIds] = useState([]);
  const [isExport, setIsExport] = useState(false);
  const getExportIds = (e) => {
    if (e.target.value === "All") {
      if (e.target.checked) {
        setExportIds((prevState) => [
          ...prevState,
          ...list.filter((v) => v.is_active === 1).map((v) => v.exp_hdr_id),
        ]);
      } else {
        setExportIds(() => []);
      }
    } else {
      const val = e.target.value;
      if (e.target.checked) {
        setExportIds((prevState) => [
          ...prevState,
          val.match(/^\d+$/) ? Number(val) : val,
        ]);
      } else {
        setExportIds((prevState) => prevState.filter((v) => v != val));
      }
    }
  };

  const downloadExportJson = async () => {
    if (exportIds.length == 0) {
      Swal.fire("", "Select atleast one Expense");
      return;
    }
    let branch_id =
      JSON.parse(localStorage.getItem("inventory"))?.userData?.branch_data?.[0]
        ?.branch_id || formInputs.branch_id;
    setIsExport(true);
    await $.post(
      `${config.apiUrl}/expense/exportExpense`,
      JSON.stringify({
        exp_hdr_ids: exportIds,
        branch_id: branch_id,
      }),
    )
      .done(function (res) {
        const jsonData = new Blob([JSON.stringify(res, null, 3)], {
          type: "text/json",
        });
        const jsonURL = window.URL.createObjectURL(jsonData);
        const link = document.createElement("a");
        document.body.appendChild(link);
        link.href = jsonURL;
        link.setAttribute("download", "Expense.json");
        link.click();
        document.body.removeChild(link);
        setIsExport(false);
        getList(filterActive);
      })
      .catch(function (err) {
        setIsExport(false);
        Swal.fire(
          "Error",
          err?.responseJSON?.data?.message || err?.responseJSON?.message,
        );
      });
  };

  const sendERP = async (type = "ERP") => {
    if (exportIds.length == 0) {
      Swal.fire("", "Select atleast one Expense");
      return;
    }

    const selectedItems = list.filter((x) => exportIds.includes(x.exp_hdr_id));
    const alreadySynced = selectedItems.filter((x) => x.sync_status == 1);

    if (alreadySynced.length > 0) {
      const nos = alreadySynced.map((x) => x.exp_hdr_no).join(", ");
      Swal.fire({
        icon: "warning",
        title: "Already synced",
        text: `Expense no ${nos} are already synced successfully. Please untick them first and then Send to ERP.`,
        confirmButtonText: "OK",
      });
      return;
    }

    setIsErpLoading(true);
    await $.post(
      `${config.apiUrl}/expense/updateErpStatus`,
      JSON.stringify({
        exp_hdr_ids: exportIds,
        is_erp: 1,
        type: type,
      }),
    )
      .done(function (res) {
        setIsErpLoading(false);
        Swal.fire({
          icon: "success",
          title: "Success",
          text:
            res?.data?.message ||
            (type === "NON-ERP"
              ? "Expense successfully marked for Non ERP."
              : "Expense successfully sent to ERP."),
        });
        getList(filterActive);
      })
      .catch(function (err) {
        setIsErpLoading(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text:
            err?.responseJSON?.data?.message ||
            err?.responseJSON?.message ||
            "Something went wrong while sending to ERP",
        });
      });
  };

  return (
    <>
      <div className="d-flex min-vh-100" style={{ background: "#DAE5FF" }}>
        <Sidebar />
        <div className="content m-1 p-2">
          <Header />

          <main className="bg-white rounded-4" id="expense">
            <div className="container-fluid p-2">
              <div className="row">
                <div className="col">
                  <Breadcrumb path={["Expense"]} />
                </div>
                <div className="col text-end" style={{display:"flex", alignItems:"end",justifyContent:"end"}}>
                  <Tippy content="Filter">
                    <img
                      onClick={() => handleFilterVisibility()}
                      src={filter}
                      className="img-fluid me-3 mt-3"
                      alt=""
                      role="button"
                      style={{ width: "2rem" }}
                    />
                  </Tippy>

                  <span className=" me-3">
                    <label className="me-1">Per Page</label>
                    <select
                      value={userCount}
                      onChange={(e) => changePageSize(e)}
                      className="custom-select"
                      style={{
                        height: "32px",
                      }}
                    >
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>

                  {(user?.role_id === 3 ||
                    user?.role_id === 4 ||
                    user?.role_id === 9 ||
                    user?.role_id === 7) && (
                    <>
                      <Link
                        to="/expense/add"
                        className="btn btn-primary px-4 py-2 mt-3"
                        style={{
                          height: "33px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          float: "right",
                        }}
                      >
                        New Expense
                      </Link>
                    </>
                  )}
                </div>
              </div>
              {filtersVisible && (
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    setIsSubmit(true);
                    setFilterActive(true);
                    currentPage > 1 ? setCurrentPage(1) : getList(true, 1);
                  }}
                  id="expenseAdd"
                  className="my-3"
                  autoComplete="off"
                >
                  <div className="row g-3 mb-2">
                    <div className="col-md-2">
                      <label htmlFor="exp_type">Expense Type</label>
                      <select
                        className="form-select"
                        name="exp_type"
                        value={formInputs.exp_type}
                        onChange={(e) =>
                          setFormInputs({
                            ...formInputs,
                            exp_type: e.target.value,
                          })
                        }
                      >
                        <option value="">All</option>
                        {config.expenseCategories.map((list) => (
                          <option value={list.value}>{list.label}</option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-2">
                      <label htmlFor="exp_hdr_no">Expense No</label>
                      <input
                        type="text"
                        className="form-control"
                        id="exp_hdr_no"
                        value={formInputs.exp_hdr_no}
                        onChange={handleInputs}
                      />
                    </div>
                    <div className="col-md-2">
                      <label htmlFor="exp_cat_id">Expense Category</label>
                      <CommonAsyncSelect
                        getOptionLabel={(o) => o.exp_cat_name}
                        getOptionValue={(o) => o.exp_cat_id}
                        noOptionsMessage={() => null}
                        placeholder=""
                        loadOptions={async (inputValue, callback) => {
                          await $.post(
                            `${config.apiUrl}/expCategory/listExpCategory`,
                            JSON.stringify({
                              paginate: 0,
                              is_active: 1,
                              ...(formInputs.exp_type && {
                                exp_cat_type: formInputs.exp_type,
                              }),
                              exp_cat_name: inputValue,
                            }),
                            function (res) {
                              callback(res.data?.list || res.data || []);
                            },
                          );
                        }}
                        isClearable={true}
                        value={selectedCategory}
                        onChange={(e) => {
                          setSelectedCategory(e);
                          setFormInputs({
                            ...formInputs,
                            exp_cat_id: e ? e.exp_cat_id : "",
                          });
                        }}
                        components={{
                          IndicatorsContainer: () => null,
                        }}
                        styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            minHeight: "0px",
                            height: "29px",
                          }),
                          valueContainer: (baseStyles, state) => ({
                            ...baseStyles,
                            paddingTop: "0px",
                            paddingBottom: "0px",
                            minHeight: "0px",
                            height: "29px",
                          }),
                          input: (baseStyles, state) => ({
                            ...baseStyles,
                            paddingTop: "0px",
                            paddingBottom: "0px",
                            marginTop: "0px",
                            marginBottom: "0px",
                            minHeight: "0px",
                            height: "29px",
                            fontSize: "12px",
                          }),
                          dropdownIndicator: (baseStyles, state) => ({
                            ...baseStyles,
                            paddingTop: "0px",
                            paddingBottom: "0px",
                          }),
                          option: (baseStyles, state) => ({
                            ...baseStyles,
                            paddingTop: "0px",
                            paddingBottom: "0px",
                          }),
                        }}
                        classNamePrefix="react-select"
                        tabSelectsValue
                      />
                    </div>
                    {/* <DateRangeFilter
                      filterDate={filterDate}
                      onChange={handleInputDate}
                    /> */}
                    <div className="col-md-2">
                      <label htmlFor="from_date">From Date</label>
                      <input
                        type="date"
                        className="form-control"
                        id="from_date"
                        value={formInputs.from_date}
                        onChange={handleInputs}
                        max={moment().format("YYYY-MM-DD")}
                      />
                    </div>
                    <div className="col-md-2">
                      <label htmlFor="to_date">To Date</label>
                      <input
                        type="date"
                        className="form-control"
                        id="to_date"
                        value={formInputs.to_date}
                        onChange={handleInputs}
                        max={moment().format("YYYY-MM-DD")}
                      />
                    </div>

                    {user.role_id != 3 && user.role_id != 4 && (
                      <div className="col-md-2">
                        <label htmlFor="branch_id">Branch</label>
                        <select
                          className="form-select"
                          id="branch_id"
                          name="branch_id"
                          value={formInputs.branch_id}
                          onChange={(e) =>
                            setFormInputs({
                              ...formInputs,
                              branch_id: e.target.value,
                            })
                          }
                        >
                          <option value={""}>select...</option>
                          {props.branchList.map((v, i) => (
                            <option key={i} value={v.value}>
                              {v.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}
                    <div className="col-md-2">
                      <label htmlFor="status">Status</label>
                      <select
                        className="form-select"
                        id="is_active"
                        name="is_active"
                        value={formInputs.is_active}
                        onChange={(e) =>
                          setFormInputs({
                            ...formInputs,
                            is_active: e.target.value,
                          })
                        }
                      >
                        {[
                          { id: "", name: "All" },
                          { id: 1, name: "Active" },
                          { id: 0, name: "In-Active" },
                        ].map((v, i) => (
                          <option
                            key={i}
                            value={v.id}
                            className={v.id === 0 ? "bg-lightgrey" : ""}
                          >
                            {v.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    {erpIntegration == 1 ? (
                      <div className="col-md-2">
                        <label htmlFor="sync_status">Sync Status</label>
                        <select
                          className="form-select"
                          id="sync_status"
                          name="sync_status"
                          value={formInputs.sync_status}
                          onChange={(e) =>
                            setFormInputs({
                              ...formInputs,
                              sync_status: e.target.value,
                            })
                          }
                        >
                          {[
                            { id: "", name: "All" },
                            { id: 0, name: "Pending" },
                            { id: 1, name: "Success" },
                            { id: 2, name: "Failed" },
                          ].map((v, i) => (
                            <option key={i} value={v.id}>
                              {v.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    ) : null}
                  </div>
                  <div className="row">
                    <div
                      className="col-md-4 mt-auto"
                      style={{ display: "flex", alignItems: "end" }}
                    >
                      <button
                        className="btn btn-primary"
                        type="submit"
                        disabled={isSubmit}
                        style={{
                          height: "35px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {isSubmit && (
                          <span className="spinner-border spinner-border-sm me-2"></span>
                        )}
                        Search
                      </button>
                      <button
                        className="btn btn-primary rounded-3 px-3 ms-2 text-white"
                        type="reset"
                        onClick={(e) => {
                          setFormInputs(initialState);
                          setSelectedCategory(null);
                          setFilterDate();
                          setExportIds([]);
                          const allCheckbox = document.getElementById("All");
                          if (allCheckbox) allCheckbox.checked = false;
                          currentPage > 1
                            ? setCurrentPage(1)
                            : getList(false, 1);
                        }}
                        style={{
                          background: "#4263eb",
                          fontSize: "14px",
                          height: "35px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        Clear Filters
                      </button>
                    </div>

                    <div className="col-md d-flex mt-auto">
                      <DownloadExcel
                        link={`${config.apiUrl}/expense/listExpense`}
                        data={{
                          ...formInputs,
                          branch_id:
                            JSON.parse(localStorage.getItem("inventory"))
                              ?.userData?.branch_data?.[0]?.branch_id ||
                            formInputs.branch_id,
                        }}
                        filename="expense"
                      />
                      <button
                        type="button"
                        className="btn btn-primary py-0 ms-2"
                        style={{
                          background: "#4263eb",
                          borderRadius: "8px",
                          fontWeight: "600",
                          fontSize: "14px",
                          height: "35px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          color: "#ffffff",
                        }}
                        onClick={downloadExportJson}
                      >
                        {isExport && (
                          <span className="spinner-border spinner-border-sm me-2"></span>
                        )}
                        Export
                      </button>
                      {erpIntegration == 1 ? (
                        <div className="btn-group ms-2">
                          <button
                            type="button"
                            className="btn btn-primary"
                            style={{
                              background: "#4263eb",
                              borderColor: "#4263eb",
                              borderTopLeftRadius: "8px",
                              borderBottomLeftRadius: "8px",
                              fontWeight: "600",
                              fontSize: "14px",
                              height: "35px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              color: "#ffffff",
                              whiteSpace: "nowrap",
                            }}
                            onClick={() => sendERP("ERP")}
                            disabled={isErpLoading}
                          >
                            {isErpLoading && (
                              <span className="spinner-border spinner-border-sm me-2"></span>
                            )}
                            Mark For ERP
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary dropdown-toggle dropdown-toggle-split"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            disabled={isErpLoading}
                            style={{
                              background: "#3b5bdb",
                              borderColor: "#3b5bdb",
                              borderTopRightRadius: "8px",
                              borderBottomRightRadius: "8px",
                              height: "35px",
                              color: "#ffffff",
                              paddingLeft: "10px",
                              paddingRight: "10px",
                            }}
                          >
                            <span className="visually-hidden">Toggle Dropdown</span>
                          </button>
                          <ul
                            className="dropdown-menu dropdown-menu-end shadow"
                            style={{ minWidth: "160px", zIndex: 1050 }}
                          >
                            <li>
                              <button
                                type="button"
                                className="dropdown-item py-2 fw-semibold"
                                onClick={() => sendERP("ERP")}
                              >
                                Mark For ERP
                              </button>
                            </li>
                            <li>
                              <button
                                type="button"
                                className="dropdown-item py-2 fw-semibold"
                                onClick={() => sendERP("NON-ERP")}
                              >
                                Mark For Non ERP
                              </button>
                            </li>
                          </ul>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </form>
              )}

              {(error || success) && (
                <div className="row mt-3">
                  <div className="col">
                    <div
                      className={`alert alert-${
                        error ? "danger" : "success"
                      } py-1 small`}
                      role="alert"
                    >
                      {error || success || ""}
                    </div>
                  </div>
                </div>
              )}

              <div className="row mb-4">
                <div className="col">
                  <table
                    className={`table ${
                      error || success ? "my-1" : "mt-4"
                    } rounded`}
                  >
                    <thead>
                      <tr>
                        <th>
                          <input
                            type="checkbox"
                            id="All"
                            value="All"
                            onChange={(e) => getExportIds(e)}
                          />
                        </th>
                        <th>Exp No</th>
                        <th>Exp Type</th>
                        <th>Payment Mode</th>
                        {user.role_id != 3 && user.role_id != 4 && (
                          <th>Branch Name</th>
                        )}
                        <th>Exp Category</th>
                        <th className="text-end">Amount</th>
                        <th style={{ textAlign: "center" }}>Date</th>
                        <th className="text-end">Export Count</th>
                        <th>Status</th>
                        {erpIntegration == 1 ? <th>Sync Status</th> : null}
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(isLoading || list.length === 0) && (
                        <tr>
                          <td colSpan={erpIntegration == 1 ? "12" : "11"} className="text-center">
                            {isLoading ? "Loading..." : "No Records"}
                          </td>
                        </tr>
                      )}

                      {list.map((v, i) => {
                        return (
                          <>
                            <tr
                              key={`pl_` + i}
                              className={v.is_active ? "" : "bg-lightgrey"}
                              style={
                                v?.export_count > 0
                                  ? {
                                      backgroundColor: `rgba(var(--theme-btn-color-rgb, 13, 202, 240), ${Math.min(
                                        v?.export_count * 0.15,
                                        1,
                                      )})`,
                                    }
                                  : {}
                              }
                            >
                              <td>
                                {v.is_active === 1 && (
                                  <input
                                    type="checkbox"
                                    value={v?.exp_hdr_id}
                                    checked={exportIds.includes(v?.exp_hdr_id)}
                                    onChange={(e) => getExportIds(e)}
                                  />
                                )}
                              </td>
                              <td>
                                <span
                                  className="link-primary user-select-none"
                                  role="button"
                                  onClick={() => toggleItemDetail(`pli_${i}`)}
                                >
                                  {v.exp_hdr_no}
                                </span>
                              </td>
                              <td>
                                {{
                                  1: "Expense",
                                  2: "Income",
                                  3: "Withdraw",
                                }[v.exp_type] || ""}
                              </td>
                              <td>
                                {config?.paymentMode?.find(
                                  (p) => p?.value === v?.payment_mode_id,
                                )?.label || "N/A"}
                              </td>
                              {user.role_id != 3 && user.role_id != 4 && (
                                <td>{v?.mst_branch?.branch_name}</td>
                              )}

                              <td>{v.exp_cat_name || "-"}</td>
                              <td className="text-end">
                                {millionComma(v?.amount)}
                              </td>
                              <td style={{ textAlign: "center" }}>
                                {Moment(v.dt_of_exp, "YYYY-MM-DD").format(
                                  "DD-MM-YYYY",
                                )}
                              </td>
                              <td className="text-end">
                                {v?.export_count || "0"}
                              </td>
                              <td className="">
                                {v.is_active ? (
                                  <span
                                    className="badge text-bg-success"
                                    style={{ fontSize: "11px" }}
                                  >
                                    Active
                                  </span>
                                ) : (
                                  <span
                                    className="badge text-bg-danger"
                                    style={{ fontSize: "11px" }}
                                  >
                                    In-Active
                                  </span>
                                )}
                              </td>
                              {erpIntegration == 1 && (
                                <td>
                                  {v.is_erp == 1
                                    ? (() => {
                                      const status = v.sync_status;

                                      if (status === 0) {
                                        return (
                                          <span
                                            className="badge bg-warning"
                                            style={{ fontSize: "11px" }}
                                          >
                                            Pending
                                          </span>
                                        );
                                      }

                                      if (status === 1) {
                                        return (
                                          <span
                                            className="badge bg-success"
                                            style={{ fontSize: "11px" }}
                                          >
                                            Success
                                          </span>
                                        );
                                      }

                                      if (status === 2) {
                                        return (
                                          <>
                                            <span
                                              className="badge bg-danger"
                                              style={{ fontSize: "11px" }}
                                            >
                                              Failed
                                            </span>

                                            <Tippy
                                              content={
                                                v?.sync_err || "Sync Error"
                                              }
                                            >
                                              <span
                                                style={{ cursor: "pointer" }}
                                              >
                                                <FaInfoCircle
                                                  style={{
                                                    fontSize: "15px",
                                                    marginLeft: "5px",
                                                  }}
                                                />
                                              </span>
                                            </Tippy>
                                          </>
                                        );
                                      }

                                      return (
                                        <span className="text-muted">-</span>
                                      );
                                    })()
                                    : "NA"}
                                </td>
                              )}
                              <td>
                                <Tippy content="View">
                                  <Link
                                    to={`/expense/view/` + v.exp_hdr_id}
                                    state={{
                                      expense: v,
                                      currentPageNo: currentPage,
                                      currentFilter: formInputs,
                                      showFilter: filtersVisible,
                                    }}
                                    className={`link-info m-1`}
                                  >
                                    <img
                                      src={viewIcon}
                                      className="img-fluid"
                                      alt=""
                                    />
                                  </Link>
                                </Tippy>
                                {/* {v.is_active == 1 && (
                                  <Tippy content="Edit">
                                    <Link
                                      to={`/expense/edit/` + v.exp_hdr_id}
                                      state={{
                                        expense: v,
                                        currentPageNo: currentPage,
                                        currentFilter: formInputs,
                                        showFilter: filtersVisible,
                                      }}
                                      className={`link-info m-1`}
                                    >
                                      <img
                                        src={editIcon}
                                        className="img-fluid"
                                        alt=""
                                      />
                                    </Link>
                                  </Tippy>
                                )} */}
                                {(user?.role_id === 3 ||
                                  user?.role_id === 4) && (
                                  <>
                                    {v.is_active == 1 &&
                                      (v?.export_count || 0) === 0 && (
                                        <Tippy content="Cancel">
                                          <a
                                            href="#cancel"
                                            onClick={(e) =>
                                              changeStatus(v.exp_hdr_id, 0)
                                            }
                                            className={`link-info m-1`}
                                          >
                                            <img
                                              src={deleteIcon}
                                              className="img-fluid"
                                              alt=""
                                            />
                                          </a>
                                        </Tippy>
                                      )}
                                  </>
                                )}
                              </td>
                            </tr>
                            <tr
                              key={`pli_` + i}
                              id={`pli_` + i}
                              className="d-none"
                            >
                              <td colSpan="11">
                                <div className="table-responsive">
                                  <table className="table table-sm table-bordered ms-auto w-50 py-0">
                                    <thead>
                                      <tr>
                                        <th>#</th>
                                        <th>Expense Description</th>
                                        {/*<th>Qty</th>*/}
                                        {/*<th>Rate</th>*/}
                                        <th>Total Amt</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {v.exp_dtl &&
                                        v.exp_dtl.map((v, i) => (
                                          <>
                                            <tr key={`plil_` + i}>
                                              <td>{i + 1}</td>
                                              <td>
                                                {v?.item_name ||
                                                  v?.mst_item?.item_name}
                                              </td>

                                              {/*<td className="text-end">*/}
                                              {/*    {parseFloat(v?.qty || 0).toFixed(2)}*/}
                                              {/*</td>*/}
                                              {/*<td className="text-end">*/}
                                              {/*    {parseFloat(*/}
                                              {/*        v?.rate || 0*/}
                                              {/*    ).toFixed(2)}*/}
                                              {/*</td>*/}
                                              <td className="text-end">
                                                {millionComma(v.amount)}
                                              </td>
                                            </tr>
                                          </>
                                        ))}
                                      <tr>
                                        <td
                                          colSpan="2"
                                          className="text-end pe-2 fw-bold"
                                        >
                                          Gross Total
                                        </td>
                                        <td className="fw-bold text-end">
                                          {millionComma(v.amount)}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </td>
                            </tr>
                          </>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <Pagination
                    nPages={Math.ceil(totalPage / userCount)}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                  />
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
}

export default ExpenseList;
